import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorPage } from '@assetmark/ui-components';
import styles from './ErrorPage.module.scss';
/**
 * No layout is needed for this page; this page exists inside the router,
 * which already wraps all pages with the default layout.
 * @constructor
 */
export const SigninRedirectPage = () => (_jsx(ErrorPage, { className: styles.page, message: "Authentication complete" }));
